export class BufferingAbortedError extends Error {
    override name = 'BufferingAbortedError';
    classType: string;
    parentIndex: number | undefined;

    constructor(classType: string, parentIndex: number | undefined, reason: string) {
        super('Aborted buffering because ' + reason);
        // Re-anchor prototype: defends against runtime Error wrappers (extensions,
        // third-party scripts) that break super()'s new.target semantics.
        Object.setPrototypeOf(this, BufferingAbortedError.prototype);
        this.classType = classType;
        this.parentIndex = parentIndex;
    }
}

export class FailedToLoadError extends Error {
    #metadata = {};

    constructor(message: string, metadata = {}) {
        super(message);
        Object.setPrototypeOf(this, FailedToLoadError.prototype);
        this.#metadata = metadata;
    }

    get metadata() {
        return this.#metadata;
    }
}

/**
 * Raised on the promise of a render task the queue gave up on — the queue was cleared or
 * destroyed, the task's scene went away, or the caller aborted it. The render did not fail;
 * nobody is waiting for its output any more, so consumers should settle quietly rather than
 * report this.
 */
export class RenderTaskDroppedError extends Error {
    override name = 'RenderTaskDroppedError';

    constructor(reason: string) {
        super('Render task dropped because ' + reason);
        Object.setPrototypeOf(this, RenderTaskDroppedError.prototype);
    }
}
